import { baseUrl } from '@/config'
import request from '@/axios'


export function getMenu(id) {
  return request({
    url: baseUrl+'/admin/menu',
    params: { parentId: id },
    method: 'get'
  })
}

export function fetchMenuTree() {
  return request({
    url: baseUrl+'/system/menu/listdata',
    method: 'post',
  })
}

export function addObj(obj) {
  console.log('obj', obj)
  return request({
    url: baseUrl+'/system/menu/save',
    method: 'post',
    params: obj,
  })
}

// 菜单状态切换

export function menuDisable(id) {
  return request({
    url: baseUrl+'/system/menu/disabled',
    method: 'post',
    params: id,
  })
}

export function delObj(id) {
  return request({
    url: baseUrl+'/system/menu/delete?id=' + id,
    method: 'post'
  })
}

export function putObj(obj) {
  return request({
    url: baseUrl+'/admin/menu',
    method: 'put',
    data: obj
  })
}

export function clearMenuCache() {
  return request({
    url: baseUrl+'/admin/menu/cache',
    method: 'delete'
  })
}

